import type { ApplicationEditions } from '@jira/platform__application-editions/src/edition.tsx';

export const getApplicationKeyFromProduct = (
	productKey: string,
): keyof ApplicationEditions | null => {
	switch (productKey) {
		case 'jira-core':
			return 'core';
		case 'jira-software':
			return 'software';
		case 'jira-servicedesk':
			return 'serviceDesk';
		case 'jira-customer-service':
			return 'customerService';
		case 'jira-product-discovery':
			return 'productDiscovery';
		default:
			return null;
	}
};
